import React from 'react';
import { useSession } from '../context/SessionContext';
import ErrorToast from './ErrorToast';

const ErrorToastWrapper: React.FC = () => {
  const { error, clearError } = useSession();
  return <ErrorToast message={error} onDismiss={clearError} />;
};

export default ErrorToastWrapper;
